import { useHotkeys } from "@/hooks/useHotkeys";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Registers global keyboard shortcuts.
 *
 *   /         → Navigate to search page
 *   Ctrl+K    → Navigate to search page
 */
export function GlobalHotkeys() {
  const navigate = useNavigate();

  const goSearch = useCallback(() => {
    navigate("/search");
  }, [navigate]);

  useHotkeys([
    { key: "/", handler: goSearch },
    { key: "k", ctrl: true, handler: goSearch },
  ]);

  return null;
}
